import { type GetHookResponse } from '../hooks'
import { featureListKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type FeatureListInput, type FeatureListSuccess, type TinyFeature } from '@terros/common'

export function useFeatures(input: FeatureListInput = {}): GetHookResponse<TinyFeature[]> {
  return useTantalimQuery<FeatureListInput, FeatureListSuccess, TinyFeature[]>({
    url: '/feature/list',
    queryKey: featureListKey(),
    input,
    convertResponse: (data) => data.features,
  })
}
